import { render, staticRenderFns } from "./WithdrawStep.vue?vue&type=template&id=12daf885&scoped=true&"
import script from "./WithdrawStep.vue?vue&type=script&lang=ts&setup=true&"
export * from "./WithdrawStep.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./WithdrawStep.vue?vue&type=style&index=0&id=12daf885&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12daf885",
  null
  
)

export default component.exports